<template>
  <div>
    <v-layout wrap offset-1>
      <v-flex xs12 text-left>
        <span class="ibmbold cgreen xsmall">Newly Added</span>
      </v-flex>
      <v-flex xs12 text-left pb-3>
        <span class="ibmbold medium">{{ title }}</span>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 pb-12 v-if="items.length > 0">
        <OwlCarousel
          :nav="true"
          :dots="
            $vuetify.breakpoint.name == 'lg' || $vuetify.breakpoint.name == 'xl'
              ? false
              : true
          "
          :responsive="owlResponsive"
        >
          <template v-for="(item, i) in items">
            <!-- <div class="parent" :key="i"> -->
            <v-layout wrap :key="i">
              <v-flex>
                <v-card tile elevation="0">
                  <v-layout wrap pa-1>
                    <v-flex xs12>
                      <img
                        style="object-fit: contain"
                        class="curve"
                        contain
                        :src="require('../../assets/Images/' + item.image)"
                      />
                    </v-flex>
                    <v-flex xs12 text-left pt-2 class="ibmsemibold small">
                      {{ item.nane }}
                    </v-flex>
                    <v-flex xs12 text-left class="xsmall ibmsemibold cgrey">
                      ₹ {{ item.price }} /kg
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
            <!-- </div> -->
          </template>

          <template slot="prev"
            ><span class="prev hidden-md-and-down">
              <div
                :class="
                  $vuetify.breakpoint.name == 'lg' ||
                  $vuetify.breakpoint.name == 'md'
                    ? 'prevlg'
                    : $vuetify.breakpoint.name == 'xl'
                    ? 'prevxl'
                    : ''
                "
              >
                <img
                  style="object-fit: contain; z-index: 1; height: 55px"
                  :src="require('./../../assets/Images/prevw.png')"
                />
              </div> </span
          ></template>

          <template slot="next"
            ><span class="next hidden-md-and-down">
              <div
                :class="
                  $vuetify.breakpoint.name == 'lg' ||
                  $vuetify.breakpoint.name == 'md'
                    ? 'nextlg'
                    : $vuetify.breakpoint.name == 'xl'
                    ? 'nextxl'
                    : ''
                "
                style="position: absolute; z-index: 1000"
              >
                <img
                  style="object-fit: contain; z-index: 1; height: 55px"
                  :src="require('./../../assets/Images/nextw.png')"
                />
              </div> </span
          ></template>
        </OwlCarousel>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["title", "items"],
  data() {
    return {
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 4, nav: false },
        960: { items: 4, nav: false },
        1264: { items: 6, nav: false },
      },
      images: [
        "c7.png",
        "c2.png",
        "c7.png",
        "c4.png",
        "c7.png",
        "c2.png",
        "c5.png",
        "c6.png",
        "c2.png",
        "c4.png",
      ],
      // items:[
      //   {
      //     image:"c2.png",
      //     nane:"Pomegranate",
      //     price:"80"
      //   },
      //   {
      //     image:"c3.png",
      //     nane:"Orange",
      //     price:"100"
      //   },
      //   {
      //     image:"c4.png",
      //     nane:"Plum",
      //     price:"70"
      //   },
      //   {
      //     image:"c5.png",
      //     nane:"Strawberry",
      //     price:"120"
      //   },
      //   {
      //     image:"c6.png",
      //     nane:"Pomegranate",
      //     price:"80"
      //   },
      //   {
      //     image:"c7.png",
      //     nane:"Kiwi",
      //     price:"80"
      //   }
      // ]
    };
  },
};
</script>
<style scoped>
.parent {
  position: relative;
}
/* .prev {
  z-index: 1000;
  margin-right: 90% !important;
} */
.prevIconlg {
  z-index: 1000;
  margin-bottom: -260px !important;
}
.prevIconxl {
  z-index: 1000;
  margin-bottom: -510px !important;
}
.prevlg {
  z-index: 1000;
  position: absolute;
  margin-top: 6.5% !important;
  /* border:2px solid white; */
  /* margin-right: 90% !important; */
}
.prevxl {
  z-index: 1000;
  position: absolute;
  margin-top: 7% !important;
  /* border:5px solid white; */
  margin-right: 90% !important;
}
/* .next {
  margin-left: 90% !important;
} */
.nextIconlg {
  z-index: 1000;
  align-content: center;
  margin-top: -25% !important;
  margin-left: 90% !important;
}
.nextIconxl {
  z-index: 1000;
  margin-top: -20% !important;
  margin-left: 90% !important;
}

.nextlg {
  /* border:2px solid white; */
  z-index: 1000;
  align-content: center;
  margin-top: -13% !important;
  margin-left: 94.3% !important;
}
.nextxl {
  z-index: 1000;
  /* border:5px solid white; */
  margin-top: -11% !important;
  margin-left: 96.5% !important;
}
</style>